/* eslint-disable max-len */
import { createSvgIcon } from "../../utils";

// SVG - 32 width, 32 height

const ShareTwitter = createSvgIcon(
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zm-7.952-2.536c0 5.096-3.88 10.976-10.976 10.976-2.176 0-4.208-.64-5.896-1.744a7.754 7.754 0 005.712-1.592 3.852 3.852 0 01-3.6-2.68 3.846 3.846 0 001.744-.064 3.862 3.862 0 01-3.096-3.784v-.048a3.79 3.79 0 001.744.48A3.84 3.84 0 017.96 11.8c0-.704.192-1.368.52-1.936a10.943 10.943 0 007.952 4.032 3.535 3.535 0 01-.104-.88 3.858 3.858 0 013.856-3.856c1.112 0 2.112.464 2.816 1.216a7.812 7.812 0 002.448-.936 3.855 3.855 0 01-1.696 2.136 7.83 7.83 0 002.216-.608 7.903 7.903 0 01-1.928 2c.008.16.008.328.008.496z"
        fill="#1DA1F2"
    />,
    "ShareTwitter",
);

export default ShareTwitter;
